import SearchBox from "../../common_nextgen/common_components/SearchScreenComponents/SearchBox";

import DisplayTable from "../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";
import ButtonsSection from "../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";
import NextGenPaginator from "../../common_nextgen/common_components/Pagination/NextGenPaginator";

import ConfirmationModal from "../../common_nextgen/common_components/Modal/ConfirmationModal";

import useClientPatientPaySchedule from "./hooks/useClientPatientPaySchedule";


const ClientPatientPaySchedule = () => {
  
  const clientPatientPayScheduleData = useClientPatientPaySchedule();

  return (
    <div class="container container-fluid">
      <ButtonsSection ctaButtons={clientPatientPayScheduleData.leftButtons} align="left" /> 
      <div className="header-section">
        <h1>
          {clientPatientPayScheduleData.screen_title} -{" "}
          <span className="heading-cod">{clientPatientPayScheduleData.screenNumber}</span>
        </h1>
      </div>
      <SearchBox
        formFields={clientPatientPayScheduleData.formFields}
        dropdownValues={clientPatientPayScheduleData.dropdownValues}
        paramsData={clientPatientPayScheduleData.paramsData}
        updataParamData={clientPatientPayScheduleData.updateParamData}
      />
      <ButtonsSection ctaButtons={clientPatientPayScheduleData.ctaButtons} />
      <DisplayTable
        data={clientPatientPayScheduleData.data}
        parmKey={clientPatientPayScheduleData.parmKey}
        menuOptions={clientPatientPayScheduleData.menuOptions}
        tableHeaders={clientPatientPayScheduleData.columnDef}
        setRowData={clientPatientPayScheduleData.setRowData}
        selectedPriceSchedules={clientPatientPayScheduleData.selectedRows}
        setSelectedPriceSchedules={clientPatientPayScheduleData.setSelectedRows}
      />
      <div className="paginator-container">
        <NextGenPaginator
          first={clientPatientPayScheduleData.first}
          rows={clientPatientPayScheduleData.rows}
          totalRecords={clientPatientPayScheduleData.totalRecords}
          currentPage={clientPatientPayScheduleData.currentPage}
          rowsPerPageOptions={[10, 25, 50]}
          onPageChange={clientPatientPayScheduleData.onPageChange}
        />
      </div>
      {clientPatientPayScheduleData.isConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={clientPatientPayScheduleData.isConfirmationModalOpen}
          onRequestClose={clientPatientPayScheduleData.closeConfirmationModal}
          onBack={clientPatientPayScheduleData.closeConfirmationModal}
          onSave={clientPatientPayScheduleData.deleteClientPatientPaySchedule}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={clientPatientPayScheduleData.setSelectedOption}
        />
      )}
      {clientPatientPayScheduleData.isInactiveConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={clientPatientPayScheduleData.isInactiveConfirmationModalOpen}
          onRequestClose={clientPatientPayScheduleData.closeInactiveConfirmationModal}
          onBack={clientPatientPayScheduleData.closeInactiveConfirmationModal}
          onSave={clientPatientPayScheduleData.inactivateRecord}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={clientPatientPayScheduleData.setInactiveSelectedOption}
        />
      )}
    </div>
  );
};

export default ClientPatientPaySchedule;
